module.exports = __webpack_public_path__ + "media/7.11bde55d.wav";